/**
 * Open the Ask panel beside the page, in a fresh conversation, with a
 * drafted message: in the composer for the person to finish, or sent at once
 * with `send`. The page underneath stays where it is, and Ask reads it as
 * context (which eval is open, which filters are set).
 */
export function openAsk(prompt, { send = false } = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('trodo:ask:open', { detail: { prompt: String(prompt || ''), send } }));
}
